module.exports = __webpack_public_path__ + "static/img/2.ffcd965.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/2.png
// module id = lwIr
// module chunks = 1